import { Color } from "./Color";
import { LineKinds } from "./LineKinds";
import { ILineStyle } from "./ILineStyle";

export class LineStyle {
  constructor(public color: Color, public kind: LineKinds = LineKinds.Normal, public width: number = 2, public opacity: number = 1) { }

  clone(): LineStyle {
    return new LineStyle(
      this.color.clone(),
      this.kind,
      this.width,
      this.opacity,
    );
  }

  static from(source: ILineStyle): LineStyle {
    if (!source) {
      return null;
    }
    return new LineStyle(Color.from(source.color), source.kind, source.width, source.opacity);
  }

  static to(source: LineStyle): ILineStyle {
    if (!source) {
      return null;
    }
    return {
      color: {
        value: source.color.value,
      },
      kind: source.kind,
      width: source.width,
      opacity: source.opacity,
    };
  }
}
